import React, { Component } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { withTheme } from 'styled-components';
import TitleWrapper from 'components/organisms/home/TitleWrapper';
import Welcome from 'components/organisms/home/Welcome';
import LandingBackground from 'assets/home_landing_splash.png';

class HomeTitleContainer extends Component {
    render() {
        const firstName = get(this.props, 'currentUser.firstName', '');
        const welcomeMessage = `Welcome back, ${firstName}!`;
        return (
            <TitleWrapper admin={this.props.admin} background={LandingBackground}>
                <Welcome>{ welcomeMessage }</Welcome>
            </TitleWrapper>

        );
    }
}

const mapStateToProps = state => ({
    currentUser: get(state, 'users.currentUser')
});

export default connect(mapStateToProps)(withTheme(HomeTitleContainer));



// WEBPACK FOOTER //
// ./src/containers/home/HomeTitleContainer.js